import React from 'react';

// Thin wrapper around the Material Symbols Rounded variable font (loaded in
// public/index.html). Renders a bold, filled glyph by default to match the
// "Material Design bold icons" look. Use semantic names, e.g.
//   <Icon name="search" />  <Icon name="directions_car" size={28} />
const Icon = ({
  name,
  size = 22,
  weight = 700,
  fill = 1,
  grade = 0,
  color,
  style,
  className = '',
  ...rest
}) => {
  return (
    <span
      className={`material-symbols-rounded ${className}`.trim()}
      aria-hidden="true"
      style={{
        fontSize: size,
        lineHeight: 1,
        color,
        userSelect: 'none',
        fontVariationSettings: `'FILL' ${fill}, 'wght' ${weight}, 'GRAD' ${grade}, 'opsz' ${size}`,
        ...style
      }}
      {...rest}
    >
      {name}
    </span>
  );
};

export default Icon;
